<h1 mat-dialog-title>Add Category</h1>
<div mat-dialog-content>
  <form [formGroup]="categoryForm">
    <mat-form-field appearance="fill" class="w-full">
      <mat-label>Category Name</mat-label>
      <input matInput formControlName="name" placeholder="Enter category name">
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="categoryForm.invalid">
    Add
  </button>
</div>
